import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
const DetailedPoem = () => {
    
    const { id } = useParams();
    const [poem, setPoem] = useState(null); 
    const [isPending, setIsPending] = useState(true); 
    const [error, setError] = useState(null); 
    useEffect(() => {
        const fetchPost = async () => {
            const response = await fetch('https://siteadeyemiwrites.herokuapp.com/api/posts')
            const json = await response.json()
            if (response.ok) {
              let  myArray = json.filter((item)  => item._id === id);
              setPoem(myArray[0]);
              setIsPending(false);
            }
            else{
                setError(true);
            }
        }
        fetchPost();
    }, [id])

    return ( 
        <div className="detailed-poem">
            {isPending && <p>Loading...</p>}
            {poem && (
                <section className="details">
                    <h1 className="poem-title"> {poem.title} </h1>
                    <pre className="poem-body">
                        { poem.body }
                    </pre>
                </section>
            )}
            {error && <p> Couldn't get tehat resource!</p>}
        </div>
     );
}
 
export default DetailedPoem;